import type { FragmentType } from '~/graphql/generated';

import { paginatorInfoFragment } from '~/graphql/documents/core';
import { useFragment } from '~/graphql/generated';

export const transformPagination = (data: FragmentType<typeof paginatorInfoFragment> | null | undefined) => {
  if (!data) {
    return null;
  }

  return useFragment(paginatorInfoFragment, data);
};
